export default function emptyToNull (str) {
  if (str === '') return null
  return str
}
